import React, { Component } from "react";
import { Button } from "react-bootstrap";

export default class MessagePrompt extends Component {
  closePage() {
    sessionStorage.clear();
    this.props.hideModal();
  }

  render() {
    return (
      <div className="dashboardComponentBg">
        <div className="componentTitle">{this.props.title}</div>

        <div className="componentLine" />

        {this.props.message !== "twrr" && this.props.message !== "mwrr" && (
          <div
            className="rulesStyle"
            style={{ display: "flex", flexDirection: "column" }}
          >
            {this.props.message.map((item, i) => {
              return <div key={i}>{item}</div>;
            })}
            {/* {this.props.message} */}
          </div>
        )}

        {this.props.message === "twrr" && (
          <div className="rulesStyle" style={{ marginBottom: "0" }}>
            نرخ بازدهی زمان وزنی (TWRR) بیانگر بازدهی کل تمامی دارایی‌های تحت
            مدیریت سبدگردان است و نشان می‌دهد که سبدگردان به طور متوسط تا چه حد
            در مدیریت سبدهای اختصاصی تحت مدیریت خود، موفق به کسب بازدهی برای
            سرمایه‌گذاران شده‌است. به عبارت دیگر سرمایه‌گذاران با توجه به بازدهی
            سبدگردان، می‌توانند عملکرد سبدگردان را ارزیابی نموده و در مورد سپردن
            مدیریت دارایی خود به سبدگردان تصمیم‌گیری کنند.
          </div>
        )}
        {this.props.message === "twrr" && (
          <div
            className="rulesStyle"
            style={{ marginBottom: "0", marginTop: "0" }}
          >
            ابتدا کل دوره‌ی مورد نظر براساس تاریخ وقوع جریان‌های نقدی (افزایش
            سرمایه یا برداشت سرمایه‌گذار) و تاریخ انعقاد قرارداد جدید سبدگردانی
            یا تاریخ خاتمه یک قرارداد سبدگردانی به زیر دوره‌های متعدد تقسیم
            می‌شود. سپس با استفاده از ارزش سبد در انتها و ابتدای هر زیردوره،
            بازده هر زیردوره و نهایتاً بازده کل را محاسبه می کنیم. برای اطلاعات
            تکمیلی و اطلاع از روابط ریاضی می توانید فایل پیوست 8 دستورالعمل
            تأسیس و فعالیت سبدگردان را از{" "}
            <a
              className="linkStyle inline"
              href="/api/public/HintFiles/Sabadgardani-peyvaste 8.pdf"
            >
              اینجا
            </a>{" "}
            دانلود و مطالعه کنید.
          </div>
        )}
        {this.props.message === "twrr" && (
          <div
            className="rulesStyle rulesStyleMessageTitle"
            style={{ marginBottom: "0", marginTop: "5px" }}
          >
            جمع بازده ریالی زیر دوره ها
          </div>
        )}
        {this.props.message === "twrr" && (
          <div className="rulesStyle" style={{ marginTop: "0" }}>
            این مقدار عبارت است از مجموع اختلاف ارزش سبد در ابتدا و انتهای
            زیردوره هایی که در قسمت TWRR درموردشان صحبت شد.
          </div>
        )}

        {this.props.message === "mwrr" && (
          <div className="rulesStyle" style={{ marginBottom: "0" }}>
            نرخ بازدهی پول وزنی(MWRR) برای هر سبد اختصاصی محاسبه می‌شود و به
            گونه‌ای طراحی شده تا بیانگر بازدهی هر سبد اختصاصی تحت مدیریت
            سبدگردان باشد.
          </div>
        )}
        {this.props.message === "mwrr" && (
          <div
            className="rulesStyle"
            style={{ marginBottom: "0", marginTop: "0" }}
          >
            MWRR با یافتن نرخ بازدهی، ارزش خالص تمامی جریانات نقدی را در زمان
            سرمایه گذاری اولیه تنزیل می‌کنیم. به عبارت دیگر مقدار اولیه سرمایه
            گذاری را برای برابر کردن جریان های نقدی آینده مانند واریز یا برداشت
            وجه تعیین می کند.
          </div>
        )}
        {this.props.message === "mwrr" && (
          <div className="rulesStyle" style={{ marginTop: "0" }}>
            نرخ بازدهی پول وزنی معادل نرخ بازده داخلی (IRR) است. برای اطلاعات
            تکمیلی و اطلاع از روابط ریاضی می توانید فایل پیوست 8 دستورالعمل
            تأسیس و فعالیت سبدگردان را از{" "}
            <a
              className="linkStyle inline"
              href="/api/public/HintFiles/Sabadgardani-peyvaste 8.pdf"
            >
              اینجا
            </a>{" "}
            دانلود و مطالعه کنید.
          </div>
        )}

        <div
          style={{
            width: "90%",
            height: "55px",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <Button
            variant={this.props.buttonVariant}
            className="formButtonStyle"
            onClick={this.closePage.bind(this)}
          >
            {this.props.buttonTitle}
          </Button>
        </div>
      </div>
    );
  }
}
